/* eslint-disable eqeqeq */
import * as signalR from "@microsoft/signalr";
import { applyCallProvider } from "../callProvider";
import {
  deleteMessage,
  newChatRecieve,
  receiveMessage,
  receiveReadReceipt,
  receiveTyping,
  removeChat,
  setUserOnline,
  updateEditedMessage,
  setReaction,
  setRenderReaction,
  addSingleContact,
  addReactions,
  addSingleAllContacts,
  setEventsRealTime,
  addSingleMainContactList,
  addParticipantRealTime,
  addSingleParticipant,
  setLastSeenRealTime,
  setLastSeenRealTimeArr,
  setMuteChatRealTime,
  setCallHistory,
  setSync,
  setSelectedContactName,
  setAllChats,
  setSingleAutoForwardChat,
  setIsExternalAllow,
  setAddRemoveParticipantsCount,
  setSingleNewChat,
  setChatParticipantCount,
  setDeletedAttachmentFile,
} from "../store/slice/ChatSlice";
import store from "../store/Store";
import webRtcCallService from "../webrtc/webRtcCallService";
import { settings as s } from "../Settings";
import { showNotification } from "../store/slice/NotificationSlice";
import {
  setRealTimeEmailData,
  setRealtimeEmailRecieve,
  setRenderNewEmail,
  setUnreadEmailCounts,
} from "../store/slice/EmailSlice";
import {
  setCallSid,
  setIsReceiveMuted,
  setIsReceiveRecording,
  setIsSendingRoomData,
  setIsShareScreen,
  setMissedCallCount,
  setSendCallChatId,
  setUserBusyModel,
} from "../store/slice/CallSlice";
import indexedDB, {
  applyHideStatusToIndexedDB,
  deleteMessageFrom_IndexedDB,
  deleteMultipleMessages_IndexedDB,
  fetchChatList_IndexDB_SortIt,
  fetchChatListIndexedDB,
  fetchMessagesFromIndexedDB,
  getAllChatsByOtherUserId_IndexedDB,
  getChatByChatIdAndUserId_IndexedDB,
  getChatByOtherUserId_IndexedDB,
  removeMessageReaction_IndexedDB,
  resyncLatestMessages,
  saveAllMessagesToIndexedDB,
  saveCallEventsToIndexedDB,
  saveChatListToIndexedDB,
  saveEventsToIndexedDB,
  updateChatName_IndexedDB,
  updateMessageFromIndexed_DB,
  updateMessageReaction_IndexedDB,
  updateMessageSeen_IndexedDB,
  updateMessageSeenGROUP_IndexedDB,
  updateUserOnlineStatus_IndexedDB,
} from "../../../utils/IndexedDBUtils";
import {
  addTasksInTableViewRealTime,
  setNewTasksNotification,
  setReRenderTableView,
  setTasksInTableView,
  setUpdateTask,
} from "../store/slice/TaskAndTicket";
let connection = null;

// Initialize SignalR connection
export const initializeSignalRConnection = (
  setCallStatus,
  setActiveGroupRooms,
  setIsGroupCallRingtone,
  setReconnectingParticipants,
) => {
  if (!connection || connection.state === "Disconnected") {
    connection = new signalR.HubConnectionBuilder()
      // .withUrl(`${s.baseUrl}/chatHub`, signalR.HttpTransportType.WebSockets) // Fallback to WebSockets
      .withUrl(`${s.baseUrl}/chatHub`)
      // Default policy gives up after ~30s, which permanently drops signaling/presence
      // when the backend restarts. Retry indefinitely with capped backoff instead, so
      // the connection re-establishes (and onreconnected re-runs sendUserOnline) once
      // the server is back.
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          if (retryContext.elapsedMilliseconds < 5000) return 1000;
          if (retryContext.elapsedMilliseconds < 30000) return 3000;
          return 10000;
        },
      })
      .build();

    connection
      .start()
      .then(async () => {
        const user_id = localStorage.getItem("user_id");
        console.log("Connected to SignalR Hub");
        await sendUserOnline(user_id);
        // Log all events to check if they are being registered
        connection.onreconnected(async () => {
          console.log("Reconnected to SignalR Hub");
          await sendUserOnline(user_id);
          // getConnectionStatus();
          const cachedChatlist = await fetchChatListIndexedDB();
          if (cachedChatlist?.length > 0) {
            for (let index = 0; index < cachedChatlist.length; index++) {
              await resyncLatestMessages(
                cachedChatlist[index]?.chatId,
                user_id,
                false,
              );
              const cachedChatList = await fetchChatListIndexedDB();
              const sortCachedChatList =
                await fetchChatList_IndexDB_SortIt(cachedChatList);
              store.dispatch(setAllChats(sortCachedChatList));
            }
          }
        });
        connection.onreconnecting(() =>
          console.log("Reconnecting to SignalR Hub"),
        );
        connection.onclose((error) =>
          console.error("Connection closed with error:", error),
        );

        // region External Messages
        connection.on("ReceiveInboundMessage", (getmessge) => {
          const payload = {
            message: getmessge,
            chatId: getmessge?.conversationId,
          };
          store.dispatch(receiveMessage(payload));
          const userId = localStorage.getItem("user_id");
          const allChats = store.getState((state) => state?.chat?.all_chats);
          const { userData } = store.getState().chat;
          const isChatExist = allChats?.chat?.all_chats?.some(
            (item) => item?.chatId === payload?.chatId,
          );

          if (!isChatExist && allChats?.chat?.isExternalFilter === true) {
            store?.dispatch(setSingleNewChat(getmessge));
          }
          allChats?.chat?.all_chats?.forEach((chat) => {
            if (
              chat?.ishide !== true &&
              getmessge?.senderId !== parseInt(userId) &&
              chat?.isMute !== true &&
              chat?.chatId === getmessge?.conversationId
            ) {
              store.dispatch(
                showNotification({
                  message: getmessge,
                  chatId: getmessge?.conversationId,
                }),
              );
              return;
            } else if (
              userData?.length > 0 &&
              userData[0]?.isExternalChatAllowed
            ) {
              store.dispatch(
                showNotification({
                  message: getmessge,
                  chatId: getmessge?.conversationId,
                }),
              );
            }
          });
        });
        connection.on("SendInboundMessage", async (sid, getmessge, tempid) => {
          const payload = {
            message: getmessge,
            chatId: getmessge?.conversationId,
            tempId: tempid.replace("$", ""),
          };
          store.dispatch(receiveMessage(payload));
          const userId_local = localStorage.getItem("user_id");
          const allChats = store.getState((state) => state?.chat?.all_chats);
          const { userData } = store.getState().chat;
          allChats?.chat?.all_chats?.forEach((chat) => {
            if (
              chat?.ishide !== true &&
              getmessge?.senderId !== parseInt(userId_local) &&
              chat?.isMute !== true &&
              chat?.chatId === getmessge?.conversationId &&
              getmessge?.senderId != userId_local
            ) {
              store.dispatch(
                showNotification({
                  message: getmessge,
                  chatId: getmessge?.conversationId,
                }),
              );
              return;
            } else if (
              userData?.length > 0 &&
              userData[0]?.isExternalChatAllowed &&
              getmessge?.senderId != userId_local
            ) {
              store.dispatch(
                showNotification({
                  message: getmessge,
                  chatId: getmessge?.conversationId,
                }),
              );
            }
          });
        });

        // region on ReceiveMessage
        connection.on("ReceiveMessage", async (message, chatId, tempid) => {
          const ChatIdLocal = localStorage.getItem("chatId");
          const userId = localStorage.getItem("user_id");
          const allChats = store.getState((state) => state?.chat?.all_chats);
          const payload = {
            message: message,
            chatId: chatId,
            tempId: tempid,
          };
          store.dispatch(receiveMessage(payload));
          allChats.chat.all_chats?.forEach((chat) => {
            if (
              chat.ishide != true &&
              message?.senderId !== parseInt(userId) &&
              chat.isMute != true &&
              chat.chatId === chatId
            ) {
              store.dispatch(showNotification({ message, chatId }));
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify(payload.message),
                );
              }
            }
          });
          //for seeing message instantly if chat is opened
          if (chatId == ChatIdLocal) {
            await SendReadReceipt(userId, chatId, message?.messageId);
          }
          await indexedDB.chats.update(chatId, {
            lastMessage: {
              createdDate: message?.createdDate,
              messageContent:
                message?.messageContent === ""
                  ? "Qouted"
                  : message?.messageContent,
              messageId: message?.messageId,
              isDraft: false,
            },
            eventDate: null,
            createdDate: message?.createdDate,
            unreadCount:
              message?.conversationId == ChatIdLocal ? 0 : message?.unreadcount,
          });
          const checkThisConvo_MsgsExistsInIndexed =
            await fetchMessagesFromIndexedDB(chatId);
          if (checkThisConvo_MsgsExistsInIndexed?.length > 0) {
            await saveAllMessagesToIndexedDB(message.conversationId, [message]);
          }
        });
        // region on ReceiveMessage attachment
        connection.on(
          "ReceiveMessages",
          async (message, chatId, participant, tempId) => {
            const userId = localStorage.getItem("user_id");
            const ChatIdLocal = localStorage.getItem("chatId");
            const payload = {
              message: message,
              chatId: chatId,
              tempId: tempId,
            };
            store.dispatch(receiveMessage(payload));
            const userNotification = participant?.some(
              (item) => item?.userId == userId,
            );
            // Show notification if not on the /chats page
            if (userNotification && message?.senderId !== parseInt(userId)) {
              store.dispatch(showNotification({ message, chatId }));
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify(payload.notification),
                );
              }
            }
            //for seeing message instantly if chat is opened
            if (chatId == ChatIdLocal) {
              await SendReadReceipt(userId, chatId, message?.messageId);
            }
            await indexedDB.chats.update(chatId, {
              lastMessage: {
                createdDate: message?.createdDate,
                messageContent:
                  message?.messageContent === null
                    ? "Attachment(s)"
                    : message?.messageContent,
                messageId: message?.messageId,
              },
              createdDate: message?.createdDate,
              unreadCount:
                message?.conversationId == ChatIdLocal
                  ? 0
                  : message?.unreadcount,
            });

            await saveAllMessagesToIndexedDB(parseInt(chatId), [message]);
          },
        );

        // region Auto Forward chat
        connection.on("ReceiveAutoForward", async (team) => {
          store.dispatch(setSingleAutoForwardChat(team));
        });
        // region System calling-provider changed (system-wide, from the DB).
        // Update the local cache + notify components so open sessions switch
        // RingCentral <-> Twilio live without a reload.
        connection.on("CallProviderChanged", (provider) => {
          applyCallProvider(provider);
        });
        // region Allow External chat
        connection.on(
          "ExternalChatAllowed",
          async (AllowedBy, AllowedTo, isExternal) => {
            const userId = localStorage.getItem("user_id");
            if (AllowedTo == userId) {
              store.dispatch(setIsExternalAllow(isExternal));
            }
          },
        );

        // region on emails Receive
        connection.on("ReceiveEmail", (email) => {
          const userId = localStorage.getItem("user_id");
          if (userId && email?.sender?.senderId?.toString() !== userId) {
            store.dispatch(setRenderNewEmail(true));
            store.dispatch(setRealTimeEmailData(email));
            store.dispatch(setUnreadEmailCounts(email?.unreadCount));
            localStorage.setItem("unreadEmailCount", email?.unreadCount);
          }
        });
        // region on ReceiveEditMessage
        connection.on("ReceiveEditMessage", async (message, chatId) => {
          const payload = {
            message,
            chatId,
          };
          await updateMessageFromIndexed_DB(
            chatId,
            message?.messageId,
            message?.messageContent,
            message?.attachments,
          );
          store.dispatch(setDeletedAttachmentFile([]));
          store.dispatch(updateEditedMessage(payload));
        });
        connection.on("ReceiveDeleteMessage", (messageId, chatId) => {
          const payload = {
            messageId,
            chatId,
          };
          // Dispatch action to update the message in the store
          store.dispatch(setDeletedAttachmentFile([]));
          store.dispatch(deleteMessage(payload));
        });

        // region On ReceiveNewChat
        connection.on("ReceiveNewChat", async (chat) => {
          const userid_local = localStorage.getItem("user_id");
          const username_local = localStorage.getItem("username");
          await saveChatListToIndexedDB([
            {
              chatId: chat?.chatId,
              name: chat?.name,
              lastMessage: chat?.lastMessage
                ? chat?.lastMessage
                : {
                    messageId: Math.floor(Math.random() * 10001),
                    messageContent:
                      chat?.conversationType !== "Single" ? "" : "Hi!",
                    createdDate: new Date(),
                    isDraft: false,
                  },
              otherUserId: chat?.otherUserId,
              picPath: chat?.picPath,
              createdDate: chat?.createdDate,
              userOnline: chat?.userOnline,
              userNickName: chat?.userNickName,
              unreadCount: chat?.unreadCount,
              lastSeen: chat?.lastSeen,
              ishide: false,
              isMute: false,
              isFav: false,
              conversationType: chat?.conversationType,
              userDeleted: false,
              isExternal: false,
              isAutoforward: false,
              eventDate: null,
              userData: { userName: username_local, userId: userid_local },
            },
          ]);
          store.dispatch(
            newChatRecieve({
              ...chat,
              lastMessage: chat?.lastMessage
                ? chat?.lastMessage
                : {
                    messageId: Math.floor(Math.random() * 10001),
                    messageContent:
                      chat?.conversationType !== "Single" ? "" : "Hi!",
                    createdDate: new Date(),
                    isDraft: false,
                  },
              userDeleted: false,
              eventDate: null,
            }),
          );
          const cachedChatList = await fetchChatListIndexedDB();
          const sortCachedChatList =
            await fetchChatList_IndexDB_SortIt(cachedChatList);
          store.dispatch(setAllChats(sortCachedChatList));
        });

        connection.on("ReceiveRemoveChat", (chatId) => {
          store.dispatch(removeChat(chatId));
        });

        connection.on(
          "ReceiveReadReceipt",
          async (readerUser, chatId, messageId, ConvoType) => {
            const payload = {
              readerUser,
              chatId,
              messageId,
              ConvoType,
            };
            store.dispatch(receiveReadReceipt(payload));
            if (ConvoType === "Group") {
              await updateMessageSeenGROUP_IndexedDB(
                chatId,
                messageId,
                readerUser,
              );
            } else if (ConvoType !== "Group") {
              await updateMessageSeen_IndexedDB(chatId, messageId, readerUser);
            }
            const messagesFromIndexedDB =
              await fetchMessagesFromIndexedDB(chatId);
            const lastSeenMessage = messagesFromIndexedDB?.filter(
              (allmsgs) =>
                allmsgs?.seenUsers?.length > 0 &&
                allmsgs?.messageId != messageId,
            );
            for (let index = 0; index < lastSeenMessage.length; index++) {
              await updateMessageSeen_IndexedDB(
                lastSeenMessage[index]?.chatId,
                lastSeenMessage[index]?.messageId,
                lastSeenMessage[index]?.seenUsers?.filter(
                  (users) => users?.userId != readerUser?.userId,
                )?.length > 0
                  ? lastSeenMessage[index]?.seenUsers?.filter(
                      (users) => users?.userId != readerUser?.userId,
                    )
                  : "",
              );
            }
          },
        );
        connection.on("ReceiveTyping", (user_id, userName, chatId) => {
          const payload = {
            user_id,
            userName,
            chatId,
          };
          store.dispatch(receiveTyping(payload));
        });
        // region userOffline
        connection.on("UserOffline", async (user_id) => {
          const payload = {
            userId: user_id,
            userOnline: false,
          };
          store.dispatch(setUserOnline(payload));
          await updateUserOnlineStatus_IndexedDB(user_id, false);
        });
        // region userOnline
        connection.on("UserOnline", async (user_id) => {
          const payload = {
            userId: user_id,
            userOnline: true,
          };
          store.dispatch(setUserOnline(payload));
          await updateUserOnlineStatus_IndexedDB(user_id, true);
        });
        // region Last Seen
        connection.on("Logout", (user_id, lastSeenMessage) => {
          const userId = localStorage.getItem("otherUserId");
          const payload = {
            userId: user_id,
            lastSeen: lastSeenMessage,
          };
          if (userId == user_id) {
            store.dispatch(setLastSeenRealTime(payload));
            localStorage.setItem("lastSeen", lastSeenMessage);
          }
          store.dispatch(setLastSeenRealTimeArr(payload));
        });

        // region Hide Conversation
        connection.on(
          "ReceiveIsHide",
          async (chatid, userid, IsHide, IsMute) => {
            const payload = { chatid, userid, IsMute, IsHide };
            store.dispatch(setMuteChatRealTime(payload));
            if (IsMute != null) {
              await indexedDB.chats.update(chatid, {
                isMute: IsMute,
              });
            }
            // if (IsHide != null) {

            //   await indexedDB.chats.update(chatid, {
            //     isHide: IsHide,
            //   });
            // }
          },
        );

        // Region ShowUserUnavailableModel
        connection.on("CallEnd", (UserId, Action) => {
          if (Action == "Rejected") {
            store.dispatch(setUserBusyModel(true));
          }
        });

        connection.on("ReceiveCall", (call) => {
          setCallStatus(call);
        });

        // ===== Native WebRTC 1:1 in-app call signaling =====
        // Inject the outbound signaling into the WebRTC engine (once).
        webRtcCallService.setSignaling({
          sendOffer: (CallerId, RecieverId, ChatId, CallType, Offer) =>
            connection.invoke(
              "SendOffer",
              parseInt(CallerId),
              parseInt(RecieverId),
              ChatId != null ? parseInt(ChatId) : null,
              CallType,
              Offer,
            ),
          sendAnswer: (CallId, RecieverId, answer) =>
            connection.invoke(
              "SendAnswer",
              parseInt(CallId),
              parseInt(RecieverId),
              answer,
            ),
          sendIce: (CallId, UserId, candidate) =>
            connection.invoke(
              "SendIceCandidate",
              parseInt(CallId),
              parseInt(UserId),
              candidate,
            ),
          sendEnd: (CallId, UserId) =>
            connection.invoke("SendCallEnd", parseInt(CallId), parseInt(UserId)),
        });

        connection.on("ReceiveCallId", (callId) => {
          webRtcCallService.onCallId(callId);
        });
        connection.on("ReceiveOffer", (callId, callerId, offer, callType) => {
          webRtcCallService.onIncomingOffer({ callId, callerId, offer, callType });
        });
        connection.on("ReceiveAnswer", (callId, receiverId, answer) => {
          webRtcCallService.onAnswer({ callId, answer });
        });
        connection.on("ReceiveIceCandidate", (callId, userId, candidate) => {
          const selfId = localStorage.getItem("user_id");
          // Ignore our own candidates echoed back (hub broadcasts to Clients.Others,
          // but guard anyway).
          if (String(userId) === String(selfId)) return;
          webRtcCallService.onRemoteIce({ callId, candidate });
        });
        connection.on("ReceiveCallEnd", (callId) => {
          webRtcCallService.onRemoteEnd({ callId });
        });
        connection.on("ReceiveCallDecline", (callId, callerId) => {
          webRtcCallService.onCallDeclined();
        });
        connection.on("ReceiveUserBusy", (callId, callerId) => {
          webRtcCallService.onUserBusy();
        });
        // region update and delete task
        connection.on(
          "TaskUpdated",
          (
            UserId,
            action,
            existingTask,
            ExistingChecks,
            oldattachments,
            attachments,
            AssignedYou,
            daysLeft,
          ) => {
            store.dispatch(
              setUpdateTask({
                userId: UserId,
                action: action,
                existingTask: {
                  assignBy: existingTask?.assignBy,
                  assignTo: existingTask?.assignTo,
                  createdBy: existingTask?.createdBy,
                  createdDate: existingTask?.createdDate,
                  deadLine: existingTask?.deadLine,
                  modifiedBy: existingTask?.modifiedBy,
                  modifiedDate: existingTask?.modifiedDate,
                  priority: existingTask?.priority,
                  status: existingTask?.status,

                  taskDescription: existingTask?.taskDescription,
                  taskId: existingTask?.taskId,
                  taskTitle: existingTask?.taskTitle,
                  daysLeft: daysLeft,
                },
                assignedYou: AssignedYou,
              }),
            );
          },
        );

        connection.on("ReceiveSetCallSid", (UserId, CallSid) => {
          if (UserId === user_id) {
            store.dispatch(setCallSid(CallSid));
          }
        });
        // region new CallLogs
        connection.on("CallHistory", async (CallHistory) => {
          await saveCallEventsToIndexedDB(CallHistory);
          await indexedDB.chats.update(
            parseInt(CallHistory[0]?.conversationId),
            {
              lastCall: {
                callParticipants: CallHistory[0]?.callParticipants,
                callStatus: CallHistory[0]?.callStatus,
                callType: CallHistory[0]?.callType,
                createdDate: new Date(),
                duration: CallHistory[0]?.duration,
              },
            },
          );
          const user_id = localStorage.getItem("user_id");
          const filterUniqueCallLogs = CallHistory?.map((item) => {
            const representative = item?.participants?.find(
              (p) => p?.userId == user_id,
            );
            if (!representative) return null;
            return {
              callId: item.callId,
              callResponse: representative?.callResponse,
              createdDate: item?.createdDate,
              duration: item?.duration,
              callStatus: item.callStatus,
              createdBy: item.createdBy,
              callParticipantId: representative?.callParticipantId,
              callType: item.callType,
              participants: [representative],
              conversationId: item?.conversationId,
              startTime: item?.startTime,
              endTime: item?.endTime,
            };
          }).filter(Boolean);

          if (filterUniqueCallLogs?.length > 0) {
            store.dispatch(setCallHistory(filterUniqueCallLogs));
          }
          const cachedChatList = await fetchChatListIndexedDB();
          const sortCachedChatList =
            await fetchChatList_IndexDB_SortIt(cachedChatList);
          store.dispatch(setAllChats(sortCachedChatList));
        });

        connection.on("MissedCallSeen", (updatedCount) => {
          store.dispatch(setMissedCallCount(updatedCount));
        });

        // Receive Muted
        connection.on("ReceiveMute", (CallId, UserId, isMuted) => {
          if (CallId && UserId && isMuted === true) {
            const payload = { CallId, UserId, isMuted };
            store.dispatch(setIsReceiveMuted(payload));
          }
          if (CallId && UserId && isMuted === false) {
            const payload = { CallId, UserId, isMuted };
            store.dispatch(setIsReceiveMuted(payload));
          }
        });
        // Receive Recording
        connection.on(
          "ReceiveRecording",
          (CallId, UserId, CallSid, IsRecord) => {
            if (CallId && UserId && CallSid && IsRecord === true) {
              const payload = { CallId, UserId, CallSid, IsRecord };
              store.dispatch(setIsReceiveRecording(payload));
            }
            if (CallId && UserId && CallSid && IsRecord === false) {
              const payload = { CallId, UserId, CallSid, IsRecord };
              store.dispatch(setIsReceiveRecording(payload));
            }
          },
        );
        // Receive Screen Sharing
        connection.on(
          "ReceiveShareScreen",
          (CallId, UserId, CallSid, IsStream, RoomName) => {
            const payload = { CallId, UserId, CallSid, IsStream, RoomName };
            store.dispatch(setIsShareScreen(payload));
          },
        );
        // Receive Group Call

        connection.on(
          "ReceiveGroupCall",
          (
            Type,
            RoomName,
            fromUserId,
            ToUserIds,
            UsersData,
            GroupPicPath,
            End,
            IsParticipate,
          ) => {
            const payload = {
              Type,
              RoomName,
              fromUserId,
              ToUserIds,
              UsersData,
              GroupPicPath,
              End,
              IsParticipate,
            };
            store.dispatch(setIsSendingRoomData(payload));
          },
        );

        // ReceiveGroupCall Status for Call End
        connection.on(
          "GroupCall",
          (GroupName, CallerId, Type, ParticipantIds, status) => {
            const payload = {
              GroupName,
              CallerId,
              Type,
              ParticipantIds,
              status,
            };
            if (payload.status === true) {
              if (ParticipantIds.includes(user_id)) {
                setActiveGroupRooms({});
                setIsGroupCallRingtone(true);
              }
            }
          },
        );
        // ReceiveReconnectingStatus for group call
        connection.on(
          "ReceiveReconnectingStatus",
          (GType, GName, SenderId, ParticipantsIds, status) => {
            if (status === true) {
              setReconnectingParticipants((prev) => [
                ...new Set([...prev, SenderId.toString()]),
              ]);
            } else if (status === false) {
              setReconnectingParticipants((prev) =>
                prev.filter((id) => id != SenderId.toString()),
              );
            }
          },
        );

        // region Add reaction On
        connection.on(
          "ReceiveReaction",
          async (MessageId, UserId, Reaction, ReactionData, chatId) => {
            const payload = {
              MessageId: ReactionData?.messageId,
              messageReactionId: ReactionData?.messageReactionId,
              UserId: ReactionData?.reactorId,
              reactorId: ReactionData?.reactorId,
              reaction: ReactionData?.reaction,
              reactor_Name: ReactionData?.name?.name,
              proifle_Pic: ReactionData?.name?.profilePicPath,
              chatId: chatId,
              reactionRemoved: ReactionData?.reactionRemoved,
            };
            await updateMessageReaction_IndexedDB(
              chatId,
              ReactionData?.messageId,
              ReactionData?.reactorId,
              ReactionData?.reaction,
              ReactionData?.name?.name,
              ReactionData?.name?.profilePicPath,
              ReactionData?.messageReactionId,
            );
            store.dispatch(setReaction(payload));
          },
        );
        // region Remove reaction On
        connection.on(
          "RemoveReaction",
          async (userId, messageReactionId, reaction, ChatId) => {
            const payload = {
              MessageId: reaction?.messageId,
              messageReactionId: messageReactionId,
              UserId: userId,
              reaction: reaction?.reaction,
              reactorId: reaction?.reactorId,
              chatId: ChatId,
              reactionRemoved: reaction?.reactionRemoved,
            };
            await removeMessageReaction_IndexedDB(
              ChatId,
              reaction?.messageId,
              messageReactionId,
            );
            store.dispatch(setReaction(payload));
          },
        );
        // region AddRemoveUser events
        connection.on("AddRemoveUser", async (Events) => {
          const userid_local = localStorage.getItem("user_id");
          store.dispatch(
            setAddRemoveParticipantsCount({
              chatId: Events?.conversationId,
              add: Events?.add,
            }),
          );
          store.dispatch(setEventsRealTime(Events));
          await saveEventsToIndexedDB([
            {
              eventMessage: Events?.eventMessage,
              eventDateTime: new Date(),
              conversationId: Events?.conversationId,
            },
          ]);
          await updateChatName_IndexedDB(Events?.conversationId, Events?.name);
          // store.dispatch(setSync(true));
          const allChats_chatSlice = store.getState(
            (state) => state?.chat?.all_chats,
          );
          const updatedChatName = allChats_chatSlice?.chat?.all_chats.map(
            (chat) => {
              if (chat?.chatId == Events?.conversationId) {
                return {
                  ...chat,
                  name: Events?.name,
                  eventDate: Events?.eventDateTime,
                };
              }
              return chat;
            },
          );
          store.dispatch(setAllChats(updatedChatName));
          const chatIDFromLocal = localStorage.getItem("chatId");
          if (chatIDFromLocal == Events?.conversationId) {
            store.dispatch(setSelectedContactName(Events?.name));
            store.dispatch(setChatParticipantCount(Event?.participantCount));
          }
          const getCachedGroupInfo = await getChatByChatIdAndUserId_IndexedDB(
            Events?.conversationId,
            Events?.add == false ? Events?.userid : Events?.userids[0],
          );
          await indexedDB.chats.update(Events?.conversationId, {
            eventDate: Events?.eventDateTime,
          });
          if (Events?.add == false && Events?.userid == userid_local) {
            await indexedDB.chats.update(getCachedGroupInfo?.chatId, {
              deleted: true,
            });
            localStorage.setItem("chatId", null);
          }
          const cachedChatList = await fetchChatListIndexedDB();
          const sortCachedChatList =
            await fetchChatList_IndexDB_SortIt(cachedChatList);
          store.dispatch(setAllChats(sortCachedChatList));
        });
        // region get Contacts
        connection.on("ReceiveNewContact", (chat) => {
          store.dispatch(addSingleAllContacts(chat));
          store.dispatch(addSingleMainContactList(chat));
        });
        // region GetParticipant
        connection.on("ReceiveChatParticipant", async (chat, model) => {
          const userId = localStorage.getItem("user_id");
          const filterUserData = model.users?.some((item) => userId == item);
          if (filterUserData === true) {
            store.dispatch(addSingleParticipant(chat));
            store.dispatch(
              showNotification({
                message: chat,
                chatId: chat?.chatId,
              }),
            );
          }
        });

        // region ReceiveCallConversationId

        connection.on("ReceiveCallConversationId", (ChatId, UserId) => {
          const userId = localStorage.getItem("user_id");
          if (userId == UserId) {
            const ChatIdString = ChatId.toString();
            store.dispatch(setSendCallChatId(ChatIdString));
          }
        });

        // region ReceiveAddParticipant
        connection.on(
          "ReceiveAddParticipant",
          (ConferenceName, fromUserId, ToUserIds) => {
            // console.log(
            //   `check ReceiveAddParticipant --->>`,
            //   ConferenceName,
            //   fromUserId,
            //   ToUserIds
            // );
          },
        );
        // region assign task on function
        connection.on("ReceiveTask", (tasks) => {
          store.dispatch(setNewTasksNotification(tasks));
        });
        connection.on("ReceiveDeleteByAdmin", async (Userid) => {
          const deletedUserChat_IndexedDB =
            await getChatByOtherUserId_IndexedDB(Userid);
          if (deletedUserChat_IndexedDB) {
            const updated = await indexedDB.chats.update(
              deletedUserChat_IndexedDB?.chatId,
              {
                userDeleted: true,
              },
            );

            if (updated) {
              const cachedChatList = await fetchChatListIndexedDB();
              const sortCachedChatList =
                await fetchChatList_IndexDB_SortIt(cachedChatList);
              store.dispatch(setAllChats(sortCachedChatList));
            } else {
              console.log(
                `Chat not found for chatId: ${deletedUserChat_IndexedDB?.chatId}`,
              );
            }
          }
        });

        connection.on("ReceiveTaskTable", (tasks) => {
          store.dispatch(addTasksInTableViewRealTime(tasks[0]));
        });

        connection.on("ReceiveUpdatedTaskTable", (tasks) => {
          store.dispatch(setReRenderTableView(tasks[0]));
        });
        connection.on("ReceiveChangeUserName", async (userupdate_info) => {
          if (userupdate_info?.userId) {
            const chat_with_this_OtherUserID_indexedDB =
              await getAllChatsByOtherUserId_IndexedDB(userupdate_info?.userId);

            await indexedDB.chats.update(
              chat_with_this_OtherUserID_indexedDB[0]?.chatId,
              {
                name:
                  userupdate_info?.firstName + " " + userupdate_info?.lastName,
              },
            );
            const allChats_chatSlice = store.getState(
              (state) => state?.chat?.all_chats,
            );
            const updatedChatName = allChats_chatSlice?.chat?.all_chats.map(
              (chat) => {
                if (
                  chat?.chatId ==
                  chat_with_this_OtherUserID_indexedDB[0]?.chatId
                ) {
                  return {
                    ...chat,
                    name:
                      userupdate_info?.firstName +
                      " " +
                      userupdate_info?.lastName,
                  };
                }
                return chat;
              },
            );
            store.dispatch(setAllChats(updatedChatName));
          }
        });
      })
      .catch((err) => {
        console.error("Error connecting to SignalR Hub:", err);
        if (err instanceof Error) {
          console.error("Detailed error:", err.message);
        }
      });
  }
};

// Function to check connection status
export const getConnectionStatus = () => {
  if (connection) {
    switch (connection.state) {
      case signalR.HubConnectionState.Disconnected:
        return "Disconnected";
      case signalR.HubConnectionState.Connecting:
        return "Connecting";
      case signalR.HubConnectionState.Connected:
        return "Connected";
      case signalR.HubConnectionState.Disconnecting:
        return "Disconnecting";
      default:
        return "Unknown";
    }
  } else {
    return "Connection not initialized";
  }
};

// region Helper function to handle SignalR operations
const invokeSignalRMethod = async (methodName, ...params) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(methodName, ...params);
      console.log(`${methodName} successfully invoked.`);
    } catch (err) {
      if (methodName === "methodName") {
        store.dispatch(setDeletedAttachmentFile([]));
      }
      console.error(`Error invoking ${methodName}:`, err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};

// Check User Online
export const sendUserOnline = async (user_id) => {
  await invokeSignalRMethod("SendUserOnline", parseInt(user_id));
};

// Function to send message
export const sendMessageToHub = async (message, tempid) => {
  await invokeSignalRMethod("SendMessage", message, tempid);
};

// Function to send message with attachments
export const sendMessageWithAttachment = async (MessageId, ChatId, tempid) => {
  await invokeSignalRMethod(
    "SendMessageWithAttachment",
    MessageId,
    ChatId,
    tempid,
  );
};
// region update messages invoke
export const SendEditMessage = async (message, DeleteDraft) => {
  await invokeSignalRMethod("SendEditMessage", message, DeleteDraft);
  if (message[0]?.deleted) {
    await deleteMultipleMessages_IndexedDB(
      message[0]?.chatId,
      message?.map((selectedmsgs) => selectedmsgs?.MessageId),
    );

    await deleteMessageFrom_IndexedDB(
      message[0]?.chatId,
      message[0]?.MessageId,
    );

    const messagesFromIndexedDB = await fetchMessagesFromIndexedDB(
      message[0]?.chatId,
    );
    await indexedDB.chats.update(parseInt(message[0]?.chatId), {
      lastMessage: {
        createdDate:
          messagesFromIndexedDB[messagesFromIndexedDB?.length - 1]?.createdDate,
        messageContent:
          messagesFromIndexedDB[messagesFromIndexedDB?.length - 1]
            ?.messageContent === null
            ? "Attachment(s)"
            : messagesFromIndexedDB[messagesFromIndexedDB?.length - 1]
                ?.messageContent,
        messageId:
          messagesFromIndexedDB[messagesFromIndexedDB?.length - 1]?.messageId,
      },
      createdDate:
        messagesFromIndexedDB[messagesFromIndexedDB?.length - 1]?.createdDate,
      unreadCount: 0,
    });
    const chatlistIn_IndexedDB = await fetchChatListIndexedDB();
    const sort_ChatList_IndexedDB =
      await fetchChatList_IndexDB_SortIt(chatlistIn_IndexedDB);
    store.dispatch(
      setAllChats(
        sort_ChatList_IndexedDB?.filter((items) => {
          return items?.ishide != true && items?.deleted != true;
        }),
      ),
    );
  }
};
// region invoke read messages
export const SendReadReceipt = async (
  readerUserId,
  chatId,
  messageId,
  No,
  ConvoType,
) => {
  try {
    await invokeSignalRMethod(
      "SendReadReceipt",
      parseInt(readerUserId),
      parseInt(chatId),
      parseInt(messageId),
      No,
      ConvoType,
    );
  } catch (err) {
    console.error(err);
  }
};
// region SendNewChat invoke
export const SendNewChat = async (chatId, users) => {
  await invokeSignalRMethod("SendNewChat", parseInt(chatId), users);
};

// region lastSeen
export const LastSeenMessage = async (userId) => {
  await invokeSignalRMethod("Logout", parseInt(userId));
};
// region Hide Conversation
export const HideConversation = async (ChatId, userId, isHide, isMute) => {
  const chatid = parseInt(ChatId);
  const userid = parseInt(userId);
  await invokeSignalRMethod("HideMute", chatid, userid, isHide, isMute);
  await indexedDB.chats.update(ChatId, { ishide: isHide });
  const payload = { chatid, userid, isMute };
  // store.dispatch(setMuteChatRealTime(payload));
};
// region Invok contacts
export const InvokeContacts = async (senderUserid, contactId, phoneNo) => {
  await invokeSignalRMethod(
    "AddNewContact",
    parseInt(senderUserid),
    parseInt(contactId),
    phoneNo,
  );
};
// region invoke AddRection
export const AddReaction = async (MessageId, UserId, Reaction, chatId) => {
  await invokeSignalRMethod(
    "AddReaction",
    MessageId,
    UserId,
    Reaction,
    parseInt(chatId),
  );
};
// region invoke RemoveRection
export const RemoveReaction = async (userId, messageReactionId, ChatId) => {
  await invokeSignalRMethod(
    "RemoveReaction",
    parseInt(userId),
    parseInt(messageReactionId),
    parseInt(ChatId),
  );
};
// region AddRemoveUser
export const AddRemoveUser = async (ConversationEventId) => {
  await invokeSignalRMethod("AddRemoveUser", parseInt(ConversationEventId));
};
// region AddChatParticipant
export const AddParticipantRealTime = async (model, AdminId) => {
  await invokeSignalRMethod("AddChatParticipant", model, parseInt(AdminId));
};
// region Email notification
export const newEmailNotification = async (email) => {
  await invokeSignalRMethod("ReceiveEmail", email);
};
// region new CallLogs
export const newCallLogs = async (CallId) => {
  await invokeSignalRMethod("CallHistory", parseInt(CallId));
};

// region assign task invoke function
export const SendTaskNotificationInvoke = async (TaskId, AssignedYou) => {
  await invokeSignalRMethod(
    "SendTaskNotification",
    parseInt(TaskId),
    AssignedYou,
  );
};

export const SendTyping = async (user_id, userName, chatId) => {
  await invokeSignalRMethod(
    "SendTyping",
    parseInt(user_id),
    userName,
    parseInt(chatId),
  );
};

export const StopConnection = async () => {
  if (connection && connection.state !== "Disconnected") {
    try {
      connection.off("ReceiveMessage");
      connection.off("ReceiveEditMessage");
      connection.off("ReceiveDeleteMessage");
      connection.off("ReceiveNewChat");
      connection.off("ReceiveReadReceipt");
      connection.off("ReceiveTyping");
      connection.off("UserOffline");
      connection.off("UserOnline");
      await connection.stop();
      console.log("SignalR disconnected");
    } catch (error) {
      console.error("Error while disconnecting SignalR:", error);
    } finally {
      connection = null;
    }
  } else {
    console.log("Connection is already disconnected or null");
  }
};

// region RemoveAttachment Invoke
export const RemoveAttachment = async (attachmentId, userId) => {
  await invokeSignalRMethod("RemoveAttachment", attachmentId, userId);
};

export const SendCallAccept = async (call, ChatId, userId) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke("CallAccept", call, ChatId, userId);
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};

export const SendMute = async (CallId, UserId, isMuted) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke("SendMute", CallId, UserId, isMuted);
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};
export const SendRecording = async (CallId, UserId, CallSid, IsRecord) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "SendRecording",
        CallId,
        UserId,
        CallSid,
        IsRecord,
      );
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};
// For Sharing Screen
export const SendShareScreen = async (
  CallId,
  UserId,
  CallSid,
  IsStream,
  RoomName,
) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "ShareScreen",
        CallId,
        UserId,
        CallSid,
        IsStream,
        RoomName,
      );
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};

// For Group CAlling
export const startGroupCall = async (
  Type,
  RoomName,
  fromUserId,
  ToUserIds,
  GroupPicPath,
  End,
  IsParticipate,
) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "startGroupCall",
        Type,
        RoomName,
        fromUserId,
        ToUserIds,
        GroupPicPath,
        End,
        IsParticipate,
      );
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};

// region MissedCallCount
export const MissedCallSeen = async (userId, callParticipants) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "MissedCallSeen",
        parseInt(userId),
        callParticipants,
      );
    } catch (err) {
      console.error("Error Missed Call Seen:", err);
    }
  }
};
// region SendCallConversationId
export const SendCallConversationId = async (ChatId, UserId) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke("SendCallConversationId", ChatId, UserId);
    } catch (err) {
      console.error("Error SendCallConversationId:", err);
    }
  }
};
// region SendAddParticipant
export const SendAddParticipant = async (
  ConferenceName,
  fromUserId,
  ToUserIds,
) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "SendAddParticipant",
        ConferenceName,
        fromUserId,
        ToUserIds,
      );
    } catch (err) {
      console.error("Error SendAddParticipant:", err);
    }
  }
};

// Region UserUnavailableModel
export const ShowUserUnavaiableModel = async (UserId, ChatId, Action) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke("CallEnd", UserId, ChatId, Action);
    } catch (err) {
      console.error("UserUnavailableModelInvokeError:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};
// region SetCallSid
export const SetCallSid = async (UserId, CallSid) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke("SetCallSid", UserId, CallSid);
    } catch (err) {
      console.error("Error SendAddParticipant:", err);
    }
  }
};

// For Group CAlling Status Call End
export const GroupCall = async (
  GroupName,
  CallerId,
  Type,
  ParticipantIds,
  status,
) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "GroupCall",
        GroupName,
        CallerId,
        Type,
        ParticipantIds,
        status,
      );
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};

// For Group call Reconnecting Status

export const SendReconnectingStatus = async (
  GType,
  GName,
  SenderId,
  ParticipantsIds,
  status,
) => {
  if (getConnectionStatus() === "Connected") {
    try {
      await connection.invoke(
        "SendReconnectingStatus",
        GType,
        GName,
        SenderId,
        ParticipantsIds,
        status,
      );
    } catch (err) {
      console.error("Error sending message:", err);
      if (err instanceof Error) {
        console.error("Detailed error:", err.message);
      }
    }
  } else {
    console.error("SignalR connection is not established or not connected.");
  }
};
